import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-372e9608"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pokemon-move" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "label_caution label-same-type"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: _ctx.move.pageURL
    }, _toDisplayString(_ctx.move.name), 9, _hoisted_2),
    _createTextVNode("（" + _toDisplayString(_ctx.learnedByString) + "）", 1),
    (_ctx.isSameType)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "タイプ一致"))
      : _createCommentVNode("", true)
  ]))
}